var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 5.45443V9.45443C15.6666 10.4544 15.3333 11.2878 14.7466 11.8744C14.1666 12.4544 13.3333 12.7878 12.3333 12.7878V14.2078C12.3333 14.7411 11.74 15.0611 11.3 14.7678L8.33331 12.7878H6.91998C6.97332 12.5878 6.99998 12.3811 6.99998 12.1678C6.99998 11.4878 6.73998 10.8611 6.31331 10.3878C5.83331 9.84111 5.11998 9.5011 4.33331 9.5011C3.58665 9.5011 2.90665 9.80778 2.41998 10.3078C2.35998 10.0411 2.33331 9.75443 2.33331 9.45443V5.45443C2.33331 3.45443 3.66665 2.12109 5.66665 2.12109H12.3333C14.3333 2.12109 15.6666 3.45443 15.6666 5.45443Z",
    stroke: "#7B61FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 12.1667C7.00002 12.9667 6.6467 13.68 6.09336 14.1667C5.62003 14.58 5.00669 14.8333 4.33335 14.8333C2.86002 14.8333 1.66669 13.64 1.66669 12.1667C1.66669 11.3267 2.05335 10.5733 2.66669 10.0867C3.12669 9.72 3.70669 9.5 4.33335 9.5C5.80669 9.5 7.00002 10.6933 7.00002 12.1667Z",
    stroke: "#7B61FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50002 11.332V12.332L3.66669 12.832",
    stroke: "#7B61FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 7.5H11.3334",
    stroke: "#7B61FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6b535b4fa2ffff8a73990e6cb8176063.svg";
export { ForwardRef as ReactComponent };